import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("tr", { class: _ctx.rowClass }, [
    _createVNode("td", null, _toDisplayString(new Intl.NumberFormat().format(_ctx.article.rank)), 1),
    _createVNode("td", null, _toDisplayString(_ctx.changeIndicator), 1),
    (_ctx.article.title)
      ? (_openBlock(), _createBlock("td", _hoisted_1, [
          _createVNode("a", { href: _ctx.link }, _toDisplayString(_ctx.normalizedTitle), 9, ["href"])
        ]))
      : (_openBlock(), _createBlock("td", _hoisted_2)),
    _createVNode("td", null, _toDisplayString(new Intl.NumberFormat().format(_ctx.article.views)), 1)
  ], 2))
}